// extracted by mini-css-extract-plugin
export default {"container":"Register_container__ahvex","title":"Register_title__EAiMb","subtitle":"Register_subtitle__b14yk","content":"Register_content__SXZZZ","login":"Register_login__ujKhg"};